"use client"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import "./home-client-v2.css"

const HomeClient = () => {
  const navigate = useNavigate()
  const [activeCategory, setActiveCategory] = useState(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const [currentTime, setCurrentTime] = useState(new Date())
  const [mainSlide, setMainSlide] = useState(0)
  const [commitmentSlide, setCommitmentSlide] = useState(0)
  const [heroSlide, setHeroSlide] = useState(0)
  const [showPopup, setShowPopup] = useState(false)
  const [weatherData, setWeatherData] = useState({ temp: "18°C", loading: true })

  // Images du diaporama principal
  const heroImages = [
    "/SolutionHotel/images/hotel-lobby-v2.png",
    "/SolutionHotel/images/hotel-lobby2-v2.png",
    "/SolutionHotel/images/hotel-lobby3-v2.png",
  ]

  // Function to fetch weather data for Tunis
  const fetchWeatherData = async () => {
    try {
      // Using a free weather API (OpenWeatherMap) - you'll need to replace with your API key
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=Tunis,TN&appid=b56ce80f1e74973836f961ebb25d8704&units=metric`,
      )
      if (response.ok) {
        const data = await response.json()
        setWeatherData({
          temp: `${Math.round(data.main.temp)}°C`,
          loading: false,
        })
      } else {
        // Fallback to estimated temperature for Tunis
        setWeatherData({ temp: "22°C", loading: false })
      }
    } catch (error) {
      // Fallback temperature for Tunis in case of error
      setWeatherData({ temp: "22°C", loading: false })
    }
  }

  useEffect(() => {
    setIsLoaded(true)
    fetchWeatherData()

    // Update time every minute
    const timer = setInterval(() => {
      setCurrentTime(new Date())
    }, 60000)

    // Auto-rotate main banner slides every 4 seconds
    const mainSlideTimer = setInterval(() => {
      setMainSlide((prev) => (prev + 1) % 3)
    }, 4000)

    // Auto-rotate commitment banner slides every 6 seconds
    const commitmentSlideTimer = setInterval(() => {
      setCommitmentSlide((prev) => (prev + 1) % 3)
    }, 6000)

    // Auto-rotate hero images every 7 seconds
    const heroSlideTimer = setInterval(() => {
      setHeroSlide((prev) => (prev + 1) % 3)
    }, 7000)

    // Show popup after 5 seconds
    const popupTimer = setTimeout(() => {
      setShowPopup(true)
    }, 5000)

    return () => {
      clearInterval(timer)
      clearInterval(mainSlideTimer)
      clearInterval(commitmentSlideTimer)
      clearInterval(heroSlideTimer)
      clearTimeout(popupTimer)
    }
  }, [])

  useEffect(() => {
    const scrollContainer = document.querySelector(".hotel-v2-feature-cards")
    if (!scrollContainer) return

    let isAutoScrolling = true

    const autoScroll = () => {
      if (!isAutoScrolling) return

      // Smooth continuous scroll
      scrollContainer.scrollLeft += 0.5 // Very slow movement

      // Reset to beginning when reaching the end
      if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth - scrollContainer.clientWidth) {
        setTimeout(() => {
          scrollContainer.scrollLeft = 0
        }, 2000) // Pause at end before restarting
      }
    }

    const scrollInterval = setInterval(autoScroll, 20) // Smooth 50fps animation

    // Pause auto-scroll when user interacts
    const handleMouseEnter = () => {
      isAutoScrolling = false
    }
    const handleMouseLeave = () => {
      isAutoScrolling = true
    }
    const handleScroll = () => {
      isAutoScrolling = false
      // Resume auto-scroll after user stops scrolling
      setTimeout(() => {
        isAutoScrolling = true
      }, 3000)
    }

    scrollContainer.addEventListener("mouseenter", handleMouseEnter)
    scrollContainer.addEventListener("mouseleave", handleMouseLeave)
    scrollContainer.addEventListener("scroll", handleScroll)

    return () => {
      clearInterval(scrollInterval)
      if (scrollContainer) {
        scrollContainer.removeEventListener("mouseenter", handleMouseEnter)
        scrollContainer.removeEventListener("mouseleave", handleMouseLeave)
        scrollContainer.removeEventListener("scroll", handleScroll)
      }
    }
  }, [])

  const formatDate = (date) => {
    return date
      .toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, ".")
  }

  const formatTime = (date) => {
    return date.toLocaleTimeString("fr-FR", {
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  const scrollToContent = () => {
    const mainContent = document.querySelector(".hotel-v2-main-content")
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: "smooth" })
    }
  }

  // Modifier les textes en français
  const mainBanners = [
    {
      id: "coffee",
      title: "UNE TASSE DE CAFÉ",
      subtitle: "POUR VOTRE AVIS",
      description: "Cliquez sur l'image et laissez votre avis",
      image: "/SolutionHotel/images/coffee-banner-v2.png",
      path: "/boissons-client",
    },
    {
      id: "restaurants",
      title: "DÉCOUVREZ NOS",
      subtitle: "RESTAURANTS",
      description: "Explorez nos spécialités culinaires et notre gastronomie",
      image: "/SolutionHotel/images/restaurant-banner-v2.png",
      path: "/RestaurantsMenus-client",
    },
    {
      id: "skylounge",
      title: "DÉTENDEZ-VOUS À",
      subtitle: "NOTRE SKY LOUNGE",
      description: "Profitez d'une vue panoramique avec des boissons premium",
      image: "/SolutionHotel/images/skylounge-banner-v2.png",
      path: "/skylounge-client",
    },
  ]

  const allFeatureCards = [
    {
      id: "restaurants",
      title: "Restaurants",
      image: "/SolutionHotel/images/restaurant.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Restaurant",
      path: "/RestaurantsMenus-client",
    },
    {
      id: "boisson",
      title: "Boissons",
      image: "/SolutionHotel/images/bar.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Bar",
      path: "/boissons-client",
    },
    {
      id: "skylounge",
      title: "Rooftop",
      image: "/SolutionHotel/images/skylounge.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Sky+Lounge",
      path: "/skylounge-client",
    },
    {
      id: "spa",
      title: "Spa",
      image: "/SolutionHotel/images/spa.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Spa",
      path: "/spas-client",
    },
    {
      id: "events",
      title: "Événements",
      image: "/SolutionHotel/images/evenement.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Events",
      path: "/evenements-client",
    },
    {
      id: "services",
      title: "Services",
      image: "/SolutionHotel/images/loisir.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Services",
      path: "/loisirs-client",
    },
    {
      id: "roomservice",
      title: "Room service",
      image: "/SolutionHotel/images/roomservice.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Room+Service",
      path: "/roomservices-client",
    },
    {
      id: "seminaire",
      title: "Séminaires",
      image: "/SolutionHotel/images/seminaire.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Business",
      path: "/seminaires-client",
    },
    {
      id: "feedback",
      title: "Avis",
      image: "/SolutionHotel/images/feedback.jpg",
      fallback: "/placeholder.svg?height=300&width=200&text=Feedback",
      url: "https://google.com",
    },
  ]

  // Commitment banner slides en français
  const commitmentBanners = [
    {
      id: "commitments",
      title: "NOS ENGAGEMENTS",
      subtitle: "Politique environnementale",
      description: "Pratiques durables pour un avenir meilleur",
      image: "/SolutionHotel/images/commitments-banner-v2.png",
      path: "/policy-client",
    },
    {
      id: "wellness",
      title: "BIEN-ÊTRE &",
      subtitle: "CONFORT",
      description: "Votre bien-être est notre priorité",
      image: "/SolutionHotel/images/spa-banner-v2.png",
      path: "/spas-client",
    },
    {
      id: "events",
      title: "ÉVÉNEMENTS",
      subtitle: "SPÉCIAUX",
      description: "Des moments mémorables créés pour vous",
      image: "/SolutionHotel/images/events-banner-v2.png",
      path: "/evenements-client",
    },
  ]

  const getCurrentMainBanner = () => mainBanners[mainSlide]
  const getCurrentCommitmentBanner = () => commitmentBanners[commitmentSlide]

  return (
    <div className="hotel-v2-app">
      {/* Hero Section with Background Slideshow */}
      <div className="hotel-v2-hero">
        <div className="hotel-v2-hero-slideshow">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`hotel-v2-hero-slide ${heroSlide === index ? "active" : ""}`}
              style={{ backgroundImage: `url("${image}")` }}
            ></div>
          ))}
        </div>
        <div className="hotel-v2-hero-overlay">
          <div className="hotel-v2-hero-header">
            <div className="hotel-v2-hero-date-time">
              <div className="hotel-v2-hero-date">{formatDate(currentTime)}</div>
              <div className="hotel-v2-hero-separator">|</div>
              <div className="hotel-v2-hero-time">{formatTime(currentTime)}</div>
              <div className="hotel-v2-hero-separator">|</div>
              <div className="hotel-v2-hero-temp">{weatherData.temp}</div>
            </div>
            <div className="hotel-v2-hero-lang">
              <span>FR</span>
              <img src="/SolutionHotel/images/fr-flag-v2.png" alt="Français" className="hotel-v2-flag" />
            </div>
          </div>

          <div className="hotel-v2-hero-content">
            <div className="hotel-v2-hero-logo">HOTEL</div>
            <div className="hotel-v2-hero-text">Bienvenue au Hotel Tunis</div>
          </div>

          <div className="hotel-v2-hero-scroll" onClick={scrollToContent}>
            <div className="hotel-v2-scroll-text">DÉFILER VERS LE BAS</div>
            <div className="hotel-v2-scroll-arrow">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 5L12 19M12 19L19 12M12 19L5 12"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <main className="hotel-v2-main">
        <div className="hotel-v2-main-content">
          {/* Main Banner with Slideshow */}
          <div
            className={`hotel-v2-banner ${getCurrentMainBanner().id}-banner`}
            onClick={() => {
              const banner = getCurrentMainBanner()
              if (banner.path.startsWith("http")) {
                window.open(banner.path, "_blank")
              } else {
                navigate(banner.path)
              }
            }}
            style={{
              backgroundImage: `url("${getCurrentMainBanner().image}")`,
            }}
          >
            <div className="hotel-v2-banner-content">
              <h1>{getCurrentMainBanner().title}</h1>
              <h2>{getCurrentMainBanner().subtitle}</h2>
              <p>{getCurrentMainBanner().description}</p>
            </div>
            <div className="hotel-v2-banner-dots">
              {mainBanners.map((_, index) => (
                <span
                  key={index}
                  className={`hotel-v2-dot ${mainSlide === index ? "active" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation()
                    setMainSlide(index)
                  }}
                ></span>
              ))}
            </div>
          </div>

          {/* Feature Cards with Horizontal Scroll */}
          <div className="hotel-v2-feature-cards-container">
            <div className="hotel-v2-feature-cards">
              {allFeatureCards.map((card) => (
                <div
                  key={card.id}
                  className="hotel-v2-feature-card"
                  onClick={() => {
                    if (card.url) {
                      window.open(card.url, "_blank")
                    } else {
                      navigate(card.path)
                    }
                  }}
                >
                  <div className="hotel-v2-feature-image">
                    <img
                      src={card.image || card.fallback}
                      alt={card.title}
                      onError={(e) => {
                        e.target.src = card.fallback || `/placeholder.svg?height=300&width=200&text=${card.title}`
                      }}
                    />
                  </div>
                  <div className="hotel-v2-feature-title">{card.title}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Commitment Banner with Slideshow */}
          <div
            className={`hotel-v2-commitment-banner ${getCurrentCommitmentBanner().id}-commitment`}
            onClick={() => {
              const banner = getCurrentCommitmentBanner()
              if (banner.path.startsWith("http")) {
                window.open(banner.path, "_blank")
              } else {
                navigate(banner.path)
              }
            }}
            style={{
              backgroundImage: `url("${getCurrentCommitmentBanner().image}")`,
            }}
          >
            <div className="hotel-v2-commitment-content">
              <h2>{getCurrentCommitmentBanner().title}</h2>
              <p>{getCurrentCommitmentBanner().subtitle}</p>
              <span className="hotel-v2-commitment-description">{getCurrentCommitmentBanner().description}</span>
            </div>
            <div className="hotel-v2-banner-dots">
              {commitmentBanners.map((_, index) => (
                <span
                  key={index}
                  className={`hotel-v2-dot ${commitmentSlide === index ? "active" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation()
                    setCommitmentSlide(index)
                  }}
                ></span>
              ))}
            </div>
          </div>

          <div className="hotel-v2-social">
            <a href="#" className="hotel-v2-social-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
            <a href="#" className="hotel-v2-social-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="currentColor" strokeWidth="2" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" stroke="currentColor" strokeWidth="2" />
                <line
                  x1="17.5"
                  y1="6.5"
                  x2="17.51"
                  y2="6.5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </a>
            <a href="#" className="hotel-v2-social-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <path
                  d="M8 12h8M16 12l-4 4M16 12l-4-4"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>

            <div className="copyright">
          <p>
            © {new Date().getFullYear()} Hotel Tunis. Tous droits réservés.
            <br />
            Créé par{" "}
            <a href="https://www.itbafa.com" target="_blank" rel="noopener noreferrer">
              <img
                src="/SolutionHotel/images/itbafa_logo_dark.png"
                alt="ITBAFA Logo"
                style={{ height: "20px", verticalAlign: "middle", marginLeft: "5px" }}
              />
            </a>
          </p>
        </div>
        <br></br>
        </div>
      </main>

      <footer className="hotel-v2-footer">
        <a href="#" className="hotel-v2-nav-item active" onClick={() => navigate("/")}>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <polyline
              points="9 22 9 12 15 12 15 22"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Accueil</span>
        </a>
        <a href="#" className="hotel-v2-nav-item" onClick={() => navigate("/RestaurantsMenus-client")}>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2M7 2v20M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Restaurants</span>
        </a>
        <a href="#" className="hotel-v2-nav-item" onClick={() => navigate("/boissons-client")}>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5 12V7a1 1 0 0 1 1-1h4l2-3h2l2 3h4a1 1 0 0 1 1 1v5M5 12l1.5 6h11L19 12M5 12h14"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Bar</span>
        </a>
        <a href="#" className="hotel-v2-nav-item" onClick={() => navigate("/loisirs-client")}>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Services</span>
        </a>
        <a href="#" className="hotel-v2-nav-item" onClick={() => navigate("/spas-client")}>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 3a6.364 6.364 0 0 0 9 9 9 9 0 1 1-9-9Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Spa</span>
        </a>
        <a
          href="#"
          className="hotel-v2-nav-item"
          onClick={() => window.open("https://google.com", "_blank")}
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Avis</span>
        </a>
      </footer>

      {/* Popup d'offres */}
      <div className={`hotel-v2-popup-overlay ${showPopup ? "active" : ""}`}>
        <div className="hotel-v2-popup">
          <div
            className="hotel-v2-popup-image"
            style={{ backgroundImage: 'url("/SolutionHotel/images/offres_popup.jpg")' }}
          >
            <button className="hotel-v2-popup-close" onClick={() => setShowPopup(false)}>
              ×
            </button>
          </div>
          <div className="hotel-v2-popup-content-wrapper">
            <div className="hotel-v2-popup-title">Offres Spéciales Hotel</div>
            <div className="hotel-v2-popup-content">
              Découvrez nos promotions exclusives et profitez de réductions exceptionnelles sur votre séjour. Réservez
              maintenant et économisez jusqu'à 30% !
            </div>
            <a
              href="#"
              className="hotel-v2-popup-button"
              onClick={(e) => {
                e.preventDefault()
                setShowPopup(false)
                navigate("/offres-client")
              }}
            >
              Découvrir les offres
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeClient
